import * as React from "react";
import { StyledStep } from "../../../components/ReactTourSteps/ReactTourSteps.styles";

export const tourSteps = [
//   {
//     selector: ".step-1",
//     content: () => (
//       <StyledStep>
//         <h1 className="step-title">Upload Reports</h1>
//         <p className="step-text">
//           Register your learners to Performance Learning here. Use the{" "}
//           <span>URN Upload </span>
//           to register usernames and passwords. Download the template to get
//           started and come back to upload the details when you are ready. <br />{" "}
//           Using
//           <span> Departmental Codes</span> you can add information about your
//           learners to filter your results by on Performance Learning. Download
//           the template and upload the details here after you register your
//           learners to Performance Learning.
//         </p>
//         {/* <p className="step-link">
//           Find out more about <span>step 1</span> in the
//           <span>Help Center</span>{" "}
//         </p> */}
//       </StyledStep>
//     ),
//     style: { background: "#2a2a2a" },
//   },
//   {
//     selector: ".step-2",
//     content: () => (
//       <StyledStep>
//         <h1 className="step-title">Select Learners/Teachers</h1>
//         <p className="step-text">
//           Click here to tell me who you want to see Performance Learning results
//           for, your learners or your teachers and I will filter your results for
//           you.
//         </p>
//       </StyledStep>
//     ),
//     style: { background: "#2a2a2a" },
//   },
  {
    selector: ".step-3",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Assessment</h1>
        <p className="step-text">
          Click here and you can tell me what Performance Learning assessment
          you want to see results for. During the year your Performance Learning
          users will do multiple Performance Learning Assessments, I'll list all
          the completed ones here for you to pick from.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-5",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Year Group</h1>
        <p className="step-text">
          Click here to tell me which year group you want to see your
          Performance Learning Assessment results for and I will show you just
          their results so that you can deep dive if you want to.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-4",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Department</h1>
        <p className="step-text">
          Want to narrow your Performance Learning results down to a specific
          department? Tell me here and I will filter the results for you.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },

  {
    selector: ".step-6",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Profile</h1>
        <p className="step-text">
          This is where I tell you how many learners you have registered to
          complete the Performance Learning Assessment, how many assessments
          have been completed and how many assessments remain incomplete.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-7",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Cohorts Bar Chart</h1>
        <p className="step-text">
          On this chart, I'll show you a monthly overview of which Alert Level
          learners or teachers who have completed the Performance Learning
          Assessment you have selected fall into.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-8",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Alert Levels</h1>
        <p className="step-text">
          Performance Learning results are broken into five Alert Levels, this
          snapshot gives you an overview of how many learners are in each level.
          Want to see who is in a specific Alert Level?
          <span> Click 'Explore Learner Performance' </span>
          and I will show you a list of all the learners in the Alert Level you
          have selected.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-11",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Number of Learners</h1>
        <p className="step-text">
          Take a look and I will show you what % of your learners who completed
          the selected assessment fall into this Alert Level.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-9",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Performance Learning Score</h1>
        <p className="step-text">
          The average Performance Learning Score is calculated from the
          Performance Learning Score for each individual who completed the
          selected assessment.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-10",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Assessment Level</h1>
        <p className="step-text">
          The Assessment Level shows the level that learners in this Alert Level
          fall into.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },

//   {
//     selector: ".step-12",
//     content: () => (
//       <StyledStep>
//         <h1 className="step-title">Generate Completion Report</h1>
//         <p className="step-text">
//           Click here and I'll generate a csv with your Performance Learning
//           usernames and info on who has completed their assessment. You'll get a
//           pop up to download the csv, and the email address registered to your
//           dashboard will receive a link.
//         </p>
//       </StyledStep>
//     ),
//     style: {
//       background: "#2a2a2a",
//     },
//   },
//   {
//     selector: ".step-13",
//     content: () => (
//       <StyledStep>
//         <h1 className="step-title">
//           Full Suite of Getting to Know You Reports
//         </h1>
//         <p className="step-text">
//           I generate each learner a one page Performance Learning Assessment
//           overview report to download all of these reports, click here!
//         </p>
//       </StyledStep>
//     ),
//     style: {
//       background: "#2a2a2a",
//     },
//   },
//   {
//     selector: ".step-14",
//     content: () => (
//       <StyledStep>
//         <h1 className="step-title">Full Suite of Reports</h1>
//         <p className="step-text">
//           I generate each learner a detailed pdf report with their Performance
//           Learning Assessment results and assessment findings, click here to
//           download the reports.
//         </p>
//       </StyledStep>
//     ),
//     style: {
//       background: "#2a2a2a",
//     },
//   },
  {
    selector: ".step-15",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Navigation</h1>
        <p className="step-text">
          <span>P is for Perceptions</span>, click here to review your
          Perception results. <span>SF is for Search Filters</span>, click here
          to review your search filters.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
];



// WEBPACK FOOTER //
// ./src/pages/DataCenter/Teacher/TeacherDataCenterTour.tsx